export const downloadFileFromLink = (url: string) => {
    window.open(url, '_self')
}
